import { debounce } from "lodash";
import { ReactNode, useEffect, useState } from "react";
import { Icon } from "../icons/icon";

const handleSearch = (searchFunction: (val: any) => void, query: any) => {
  searchFunction(query);
};

const handleDebouncedSearch = debounce(handleSearch, 800);

export const SearchInput = ({
  searchFunction = () => {},
  placeholder = "Search",
  className = "",
  iconClassName = "",
  iconDimension = 20,
  customElement,
  debouncedSearch = true,
}: {
  searchFunction?: (val: string | undefined) => void;
  placeholder?: string;
  className?: string;
  iconClassName?: string;
  iconDimension?: number;
  customElement?: ReactNode;
  debouncedSearch?: boolean;
}) => {
  const [searchParams, setSearchParams] = useState<string>("");

  useEffect(() => {
    if (debouncedSearch) {
      handleDebouncedSearch(searchFunction, searchParams || undefined);
    }
    // eslint-disable-next-line
  }, [searchParams]);

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        if (!debouncedSearch) {
          searchFunction(searchParams);
        }
      }}
      className={`
        flex flex-row
        gap-4 px-4 py-3
        w-full min-w-[200px] bg-white
        border border-pry-dark-green-300/10
        rounded-lg ${className}
        `}
    >
      <Icon
        svg="search-icon"
        width={iconDimension}
        height={iconDimension}
        className={iconClassName}
      />

      <input
        type="text"
        value={searchParams}
        onChange={(e) => setSearchParams(e.target.value)}
        autoComplete="off"
        className={`
            autofill:focus:bg-transparent autofill:bg-transparent
            outline-none focus:outline-none
            bg-transparent w-full
            text-sm font-medium
            `}
        placeholder={placeholder}
      />

      {!!searchParams && (
        <button
          type="button"
          onClick={(e) => {
            setSearchParams("");
            searchFunction(undefined);
          }}
          className="w-fit"
        >
          <Icon
            svg="circle-close"
            width={iconDimension}
            height={iconDimension}
            className="text-pry-dark-green-300/50"
          />
        </button>
      )}

      {customElement && !searchParams ? (
        <button
          type="submit"
          onClick={(e) => {
            e.stopPropagation();
            searchFunction(searchParams);
          }}
          className="w-fit"
        >
          {customElement}
        </button>
      ) : undefined}
    </form>
  );
};
